import {
	GET_PROGRAMS,
	GET_PROGRAMS_ERROR,
	GET_PROGRAMS_SUCCESS,
	GET_SALES_PASSENGERS,
	GET_SALES_PASSENGERS_ERROR,
	GET_SALES_PASSENGERS_SUCCESS,
	GET_SALES_PASSENGERS_NOT_FOUND,
	MY_PASSENGERS_FILTERED
} from "../shared/constants";
import { getUserToken } from "../shared/utils";
import { getAllProgramFidelity, getSalesReport, getFidelities } from "../shared/requests-api";

export const filterMyPassengersStatements = (
	currentStatements,
	filteredStatements,
	instantSearch
) => {
	return function(dispatch) {
		const mergedStatements = Object.assign({}, currentStatements, filteredStatements);

		if (instantSearch) {
			dispatch(filterMyPassengers(mergedStatements));
		}

		dispatch({
			type: MY_PASSENGERS_FILTERED,
			payload: { filteredStatements: mergedStatements }
		});
	};
};

export const filterMyPassengers = ({ startDate, endDate, programId }) => {
	return dispatch => {
		dispatch({ type: GET_SALES_PASSENGERS });

		getSalesReport(getUserToken(), programId, startDate, endDate)
			.then(response => {
				dispatch({ type: GET_SALES_PASSENGERS_SUCCESS, payload: response.data });
			})
			.catch(e => {
				if (e.response.status == 404) {
					dispatch({ type: GET_SALES_PASSENGERS_NOT_FOUND });
				} else {
					dispatch({ type: GET_SALES_PASSENGERS_ERROR, payload: e });
				}
			});
	};
};

export const requestUserProgramFidelity = () => {
	return dispatch => {
		dispatch({ type: GET_PROGRAMS });

		getFidelities()
			.then(response => {
				let airlines = response.data;

				let programs = airlines.map(airline => {
					let fidelity = airline.fidelities.find(
						fidelity => airline.fidelities.length == 1 || fidelity.id == 3
					);
					return {
						id: fidelity.id,
						name: fidelity.name,
						company: airline.airlineAcronym
					};
				});

				programs = programs.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

				dispatch({ type: GET_PROGRAMS_SUCCESS, payload: programs });
			})
			.catch(e => {
				dispatch({ type: GET_PROGRAMS_ERROR, payload: e });
			});
	};
};
